import { match } from 'react-router';
import { IRootStore } from '@src/models';
import { ROUTES } from 'src/constants';

type HandlerArgs = {
  action: {
    tree: IRootStore;
  };
  match: match<{
    jobId: string;
    applicationId: string;
  }>;
};

export const applicationFlows = {
  [ROUTES.jobs.applications.application]: {
    call: ({ action, match }: HandlerArgs) => {
      const { jobId } = match.params;
      action.tree.jobsStore.fetchAnonymousJob(jobId);
      action.tree.resourcesStore.getCountries();
      action.tree.resourcesStore.fetchAllThemes();
      action.tree.resourcesStore.getIndustries();
      action.tree.resourcesStore.getJobFunctions();
      action.tree.resourcesStore.getDegrees();
      action.tree.resourcesStore.getMajors();
      action.tree.resourcesStore.getLanguages();
      action.tree.resourcesStore.getLanguagesLevels();
    },
    abort: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.abort();
    }
  }
};
